<template>
	<div class="game-screen">
		<div class="game-screen backdrop paw-bg">
			<transition name="fade" @after-enter="loadExplanations">>
				<div class="content" v-if="angelsGone">
					<h1 class="game-over">Game Over</h1>
					<ScoreMedallion />
				</div>
			</transition>
		</div>
		<transition name="angel-ascend" @after-leave="completeAngelWipe">
			<div class="angel-container" v-if="isTransitioning">
				<div
					v-for="n in angelCount"
					:key="n"
					class="cat angel"
					:class="randomBreedName()"
					style="width:10vw;height:10vw;"
					:style="randomAngelStyle()"
				></div>
			</div>
		</transition>
	</div>
</template>

<script>
import ScoreMedallion from '@/components/abstract/ScoreMedallion';
import Cookies from 'js-cookie';
import soundFx from "@/mixins/sound-fx";
import { randomBetween } from "@/mixins/random";
import { mapState, mapGetters, mapActions } from "vuex";
import { MIXED_LITTER_COOKIE_KEY } from "@/constants";

export default {
	name: 'GameOver',
	mixins: [soundFx],
	props: ["isTransitioning"],
	components: {
		ScoreMedallion,
	},
	computed: {
		...mapGetters(["currentStageSettings", "randomBreedName"]),
		...mapState({
			ui: state => state.config.ui.game_over,
			music: state => state.config.stages[0].music,
			score: state => state.score.score,
			deadCats: state => state.cats.dead,
		}),
	},
	data() {
		return {
			angelsGone: false,
			angelCount: 100,
		};
	},
	watch: {
		isTransitioning(isTransitioning, wasTransitioning) {
			if (isTransitioning && !wasTransitioning) {
				const stingerSrc = this.soundObjectToArray(this.currentStageSettings.ending_stinger);
				const musicSrc = this.soundObjectToArray(this.music);

				const stinger = this.createHowl(stingerSrc, {
					volume: 1,
				});

				const music = this.createHowl(musicSrc, {
					loop: true,
				});

				this.transitionMusic({ stinger, music });
			}
		},
	},
	methods: {
		...mapActions([
			"transitionMusic",
			"startClock",
			"stopClock",
			"sendEvent",
		]),
		completeAngelWipe() {
			this.angelsGone = true;
		},
		loadExplanations() {
			this.startClock();
			this.$store.commit("addTimer", {
				ref: "gameOver",
				duration: 2000,
				action: () => {
					this.$store.dispatch("loadView", {
						view: "EndScreen",
					});
					this.$store.commit("removeAllTimers");
					this.stopClock();
				},
			});
		},
		incrememntCatDebt() {
			this.$http.put('/wp-json/dev-api/v1/cat-debt/', {
				increment: this.deadCats,
			});
		},
		randomAngelStyle() {
			return {
				transform: `scale(${randomBetween(1, 4)}) translate(${randomBetween(-10, 10)}%, ${randomBetween(-10, 10)}%)`,
				animationDelay: `-${randomBetween(0, 750)}ms`,
				zIndex: randomBetween(1, this.angelCount),
			};
		},
	},
	mounted() {
		const roundedScore = Math.round(this.score / 1000) * 1000;
		this.incrememntCatDebt();
		this.sendEvent({
			ec: "Post-Game",
			ea:	"Game Complete",
			el: roundedScore.toString(),
		});
		Cookies.set(MIXED_LITTER_COOKIE_KEY, true);
	},
};
</script>

<style lang="scss" scoped>
	.game-screen {
		overflow: visible;
		z-index: 99999;
	}

	.angel-container {
		display: flex;
		flex-wrap: wrap;
		width: 110vw;
		height: 110vh;
		position: fixed;
		top: -5vh;
		left: -5vw;
		z-index: 99999;
	}

	.angel {
		position: relative;
		flex-shrink: 0;
	}

	.game-over {
		font-size: 80px;
		color: $brand-color-alt-dark;
		text-transform: uppercase;

		@include mobile {
			font-size: 50px;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/views/GameOver.vue